<template>
  <transition name="in">
    <div class="get" ontouchmove="return false" @click="close">
      <div class="body" @click.stop>
        <p class="tit">领取成功</p>
        <p class="word">恭喜您完成10次{{type==1?'飞行':'入住'}}任务</p>
        <p class="txt">{{year}}年<br>免费{{type==1?'机票':'酒店'}}</p>
        <p class="range">¥ {{price}}以下可用</p>
        <p class="use" @click="toUse">去使用</p>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: ['price', 'type'],
  computed: {
    year() {
      return new Date().getFullYear()
    }
  },
  methods: {
    toUse() {
      this.$emit('use')
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>
<style scoped lang="less">
.get {
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9998;
  .body {
    width: 300px;
    height: 341px;
    background: url('//file.40017.cn/appresource/image/tin1/bg_popups_successful.png') no-repeat top center;
    background-size: cover;
    border-radius: 4px;
    overflow: hidden;
    text-align: center;
    -webkit-transform: translate(-50%, -50%);
    position: absolute;
    top: 50%;
    left: 50%;
    .tit {
      font-size: 18px;
      line-height: 22px;
      color: #333;
      padding-top: 28px;
      font-weight: bold;
    }
    .word {
      font-size: 14px;
      line-height: 16px;
      color: #82848c;
      padding-top: 16px;
    }
    .txt {
      padding-top: 48px;
      font-size: 19px;
      font-weight: bold;
      color: #247bff;
      line-height: 23px;
    }
    .range {
      padding-top: 17px;
      font-size: 12px;
      color: #37383d;
      line-height: 16px;
    }
    .use {
      margin: 66px auto 0;
      width: 230px;
      height: 44px;
      line-height: 44px;
      color: #fff;
      font-size: 18px;
      background: #247bff;
      text-align: center;
      border-radius: 4px;
      font-weight: bold;
    }
  }
}

.in-enter,
.in-leave-to {
  opacity: 0;
}

.in-enter-active,
.in-leave-active {
  -webkit-transition: opacity 0.4s;
  transition: opacity 0.4s;
}
</style>